// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { WorkshopInformation } from '../../../types/Model';

export interface WorkshopRequestPayload {
  id: number;
  preventLoading?: boolean;
}
export interface WorkshopSuccessPayload {
  workshopData: WorkshopInformation;
}

export interface WorkshopFailPayload {
  error: Error;
}

const getWorkshopDataActions = createAsyncAction(
  'elearning/GET_WORKSHOP_DATA',
  'elearning/GET_WORKSHOP_DATA_SUCCESS',
  'elearning/GET_WORKSHOP_DATA_FAIL'
)<
  WorkshopRequestPayload,
  WorkshopSuccessPayload,
  WorkshopFailPayload
>();

export { getWorkshopDataActions as default};
